export const scrollToContainerTop = (containerId) => {
    const container = document.getElementById(containerId);
    if (!container)
        return;
    container.scrollTo(0, 0);
};
